// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>
// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
import { Turbo } from '@hotwired/turbo-rails'
Turbo.session.drive = false
window.Turbo = Turbo
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import { createApp } from 'vue';
import './vanila';
import './vue/shared/input-file';
import './vue/shared/pesquisa-geral';
import '../entrypoints/widgets/main';
import '../src/plugins/driver.js';
import './vue/filtro/main';
import './vue/filtro/relatorio-main';
import './vue/filtro/relatorio-pedidos-main';
import './vue/filtro/listagem-filtros';
import './vue/filtro/botao-carregar-mais';
import '../src/js-flash/';
import "./controllers";

window.createVueApp = createApp;

window.importModule=(pathComp)=>{
  import(/* @vite-ignore */ pathComp);
}
